var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("ih i-ih_" + _vm.icon + " " + _vm.compiledColorClasses),style:(_vm.styleObject)})}
var staticRenderFns = []

export { render, staticRenderFns }